module.exports = __webpack_public_path__ + "img/android.aebd3b4.png";